import { render, staticRenderFns } from "./TeachBrands.vue?vue&type=template&id=6637d006&scoped=true&"
import script from "./TeachBrands.vue?vue&type=script&lang=js&"
export * from "./TeachBrands.vue?vue&type=script&lang=js&"
import style0 from "./TeachBrands.vue?vue&type=style&index=0&id=6637d006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637d006",
  null
  
)

export default component.exports